import React, { Suspense } from 'react';
import { Route, Routes } from 'react-router-dom';


const Register = React.lazy(() => import('../../pages/auth/Register/Register.tsx'));
const Login = React.lazy(() => import('../../pages/auth/Login/Login.tsx'));
const Forgot = React.lazy(() => import('../../pages/auth/forgot_password/ForgotPassword.tsx'));
const VerifyOtp=React.lazy(()=> import('../../pages/auth/verify_otp/VerifyOtp.tsx'))



const AuthLayout = () => {
    return (
        <div className="background">
            <Suspense fallback={<div>Loading...</div>}>
                <Routes>
                    <Route path="/" element={<Register />} />
                    <Route path="/login" element={<Login />} />
                    <Route path="/forgot_password" element={<Forgot />} />
                    <Route path="/verify_otp" element={<VerifyOtp />} />
                </Routes>
            </Suspense>
        </div>
    );
};

export default AuthLayout;
